export default __webpack_public_path__ + "static/media/avatar_9.1b47fedd.png";